import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";

const Layout = ({ children }) => (
    <div className="app-wrapper">
        <Sidebar />
        <div className="app-main">
            <Header />
            <div className="app-content">
                {children}
            </div>
        </div>
    </div>
);

export default Layout;
